import LazyLoad from "vanilla-lazyload/dist/lazyload.min";

window.addEventListener("DOMContentLoaded", () => {
  new LazyLoad({
    elements_selector: "[data-lazy]",
  });
});
